// Permisos RBAC de Conciliación, los mismos que exige cada endpoint de reconciliation-engine-business
// (scripts/rbac del motor), todos con alcance TENANT. Sin la clave, la acción se esconde.

export const RECONCILIATION_PERMISSIONS = {
    definitionRead: 'reconciliation.definition.read',
    definitionConfigure: 'reconciliation.definition.configure',
    runRead: 'reconciliation.run.read',
    runExecute: 'reconciliation.run.execute',
    itemRead: 'reconciliation.item.read',
    itemResolve: 'reconciliation.item.resolve',
    itemNoteAdd: 'reconciliation.item.note.add',
} as const;

export interface ReconciliationAbilities {
    canReadDefinitions: boolean;
    canReadRuns: boolean;
    canExecuteRun: boolean;
    canReadItems: boolean;
    canResolveItem: boolean;
    canAddNote: boolean;
}

export function resolveReconciliationAbilities(
    granted: ReadonlySet<string>,
): ReconciliationAbilities {
    const has = (key: string) => granted.has(key);
    const p = RECONCILIATION_PERMISSIONS;
    return {
        canReadDefinitions: has(p.definitionRead),
        canReadRuns: has(p.runRead),
        canExecuteRun: has(p.runExecute),
        canReadItems: has(p.itemRead),
        canResolveItem: has(p.itemResolve),
        canAddNote: has(p.itemNoteAdd),
    };
}
